import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index-escalas',
  templateUrl: './index-escalas.component.html',
  styles: []
})
export class IndexEscalasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
